export const WaterUserActionType = Object.freeze({
  TOGGLE_ABOUT: "Water User:: Toggling the About Drawer",
  SET_CHART: "Water User:: Select Chart",
  SET_SCENARIO: "Water User:: Select Scenario",
  RESET_CHART: "Water User:: Reset Selected Chart to 0 (Map)",
  // CITIES
  SET_ALL_CITIES: "City Water User:: Get all Cities",
  SET_CITY_METRICS: "City Water User:: Set City Metrics",
  SET_CITY_WATER_AVAILABILITY: "City Water User:: Set City Available CO water",
  SET_SELECTED_CITY: "City Water User:: Selected City",
  RESET_SELECTED_CITY: "City Water User:: Reset Selected City",
  SET_ALL_CITIES_WATER_USE: "City Water User:: Set water use for all cities",
  // TRIBES
  SET_ALL_TRIBES: "Tribe Water User:: Get all Tribes",
  SET_SELECTED_TRIBE: "Tribe Water User:: Selected Tribe",
  SET_TRIBAL_SHORTAGES: "Tribe Water User:: Set tribal shortages",
  SET_TRIBE_METRICS: "Tribe Water User:: Set Tribe Metrics",
  RESET_SELECTED_TRIBE: "City Water User:: Reset Selected Tribe",
  // INDUSTRY
  SET_INDUSTRY_SHORTAGES: "Industry Water User:: Set industry shortages",
  SET_INDUSTRY_METRICS: "Industry Water User:: Set Industry metrics",
  SET_SELECTED_INDUSTRY: "Industry Water User:: Selected Industry",
  RESET_SELECTED_INDUSTRY: "Industry Water User:: Reset Selected Industry",
  // AGRICULTURE
  SET_ALL_AGRICULTURE: "Agriculture Water User:: Get Agriculture Districts",
  SET_AGRICULTURE_METRICS: "Agriculture Water User:: Set Agriculture Metrics",
  SET_SELECTED_AGRICULTURE: "Agriculture Water User:: Selected Agriculture",
  SET_DISTRICT_WATER: "Agriculture Water User:: Set District Water",
  SET_WATER_USER: "Agriculture Water User:: Set Water User",
  SET_WATER_USER_OPTIONS: "Agriculture Water User:: Set Water User Options",
  SET_DELIVERIES: "Agriculture Water User:: Set Wate Deliveries",
  RESET_SELECTED_AGRICULTURE: "City Water User:: Reset Selected Agriculture",
});
